import { EParkingType } from 'shared/types/filters/advanced/parkingType';

export const mapParkingTypeLabel = {
  [EParkingType.AllTypes]: 'Есть',
  [EParkingType.Underground]: 'Подземная',
  [EParkingType.Ground]: 'Наземная',
  [EParkingType.Multilevel]: 'Многоуровневая',
  [EParkingType.Rooftop]: 'На крыше',
};
